<section
  class="stepper-wrapper"
  [class.long-stepper]="enableDividersResize"
  (mouseover)="hovering(true)"
  (mouseleave)="hovering(false)"
>
  <ng-container *ngFor="let step of steps; let i = index;">
    <button
      class="step mat-body"
      *ngIf="step.state?.value === localActiveValue; else inactive;"
      [ngStyle]="customActiveStepStyles"
      data-cy="stepper-active-step"
    >
      <ng-container [ngTemplateOutlet]="step.stepLabel.template"></ng-container>
    </button>
    <ng-template #inactive>
      <mojo-inactive-step
        [index]="i"
        [completed]="step.completed"
        [step]="step"
        [clickable]="isClickable(i)"
        [isCustomStep]="customSteps[i]"
        [loading]="loadingSteps[i]"
        [customColor]="overwriteColors?.primary"
        [showLabel]="showInactiveLabel"
        [showTooltip]="showInactiveTooltip"
        [disableStepper]="disableStepper"
        (stepSelected)="onClick(step, i)"
        data-cy="stepper-inactive-step"
      >
      </mojo-inactive-step>
    </ng-template>
    <span
      class="divider"
      [class.inactive-divider]="((i >= activeIndex) || disableStepper)"
      [style.width.rem]="isHovering ? dividerWidthOnHover : dividerWidth"
      [ngStyle]="{
            backgroundColor: i < activeIndex && overwriteColors?.primary ? overwriteColors?.primary : undefined
          }"
      *ngIf="steps?.length !== i + 1"
    ></span>
  </ng-container>
</section>
